import { render, staticRenderFns } from "./ErrorStockImport.vue?vue&type=template&id=03de5ff2&"
import script from "./ErrorStockImport.vue?vue&type=script&lang=js&"
export * from "./ErrorStockImport.vue?vue&type=script&lang=js&"
import style0 from "./ErrorStockImport.vue?vue&type=style&index=0&id=03de5ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports